import { useState } from "react";
import { Check, Loader2, ShieldCheck, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { TEAL } from "@/lib/copilot";

const AUD = [["everyone", "Everyone"], ["adults", "Adults only"], ["parents", "Parents only"]];

export default function ActionCard({ hubId, card, readOnly }) {
  const [c, setC] = useState(card);
  const [busy, setBusy] = useState(false);
  const [aud, setAud] = useState(card.body?.audience || "everyone");
  const base = `/organizations/${hubId}/copilot/actions/${c.id}`;
  const confirm = async () => {
    setBusy(true);
    try { const { data } = await api.post(`${base}/confirm`, { audience: aud }); setC({ ...c, ...data }); } catch (e) { setC({ ...c, status: "failed", error: errMsg(e) }); } finally { setBusy(false); }
  };
  const cancel = async () => { setC({ ...c, status: "cancelled" }); api.post(`${base}/cancel`).catch(() => {}); };
  const pending = c.status === "pending" && !readOnly;
  return (
    <div className="mt-2 rounded-2xl border p-4" style={{ borderColor: `rgba(${TEAL},0.45)`, background: `rgba(${TEAL},0.07)` }} data-testid={`action-card-${c.id}`} data-status={c.status}>
      <p className="flex items-center gap-1.5 text-[10px] font-black uppercase tracking-[0.18em]" style={{ color: `rgb(${TEAL})` }}><ShieldCheck className="h-3.5 w-3.5" /> Confirm this change</p>
      <p className="mt-1.5 break-words font-semibold text-q-text" data-testid="action-card-summary">{c.summary}</p>
      {c.audiences && pending && (
        <div className="mt-3 flex flex-wrap gap-1.5" data-testid="action-card-audience">
          {AUD.map(([v, l]) => (
            <button key={v} className="min-h-[44px] rounded-full px-3 text-xs font-bold" onClick={() => setAud(v)} aria-pressed={aud === v}
              style={aud === v ? { background: `rgb(${TEAL})`, color: "#042f2a" } : { background: "rgb(var(--q-raised))", color: "rgb(var(--q-muted))" }} data-testid={`action-card-audience-${v}`}>{l}</button>
          ))}
        </div>
      )}
      {pending && (
        <div className="mt-3 flex gap-2">
          <button className="q-btn min-h-[44px] font-extrabold" style={{ background: `rgb(${TEAL})`, color: "#042f2a" }} disabled={busy} onClick={confirm} data-testid="action-card-confirm">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />} Confirm
          </button>
          <button className="q-btn q-btn-ghost min-h-[44px]" disabled={busy} onClick={cancel} data-testid="action-card-cancel"><X className="h-4 w-4" /> Cancel</button>
        </div>
      )}
      {c.status === "done" && <p className="mt-2 text-sm font-bold" style={{ color: `rgb(${TEAL})` }} data-testid="action-card-result">{c.result}</p>}
      {["failed", "expired"].includes(c.status) && <p className="mt-2 text-sm font-bold text-red-300" data-testid="action-card-error">{c.error || "This can't be done anymore"}</p>}
      {c.status === "cancelled" && <p className="mt-2 text-sm text-q-faint" data-testid="action-card-cancelled">Cancelled. Nothing changed.</p>}
    </div>
  );
}
